export default __webpack_public_path__ + "static/media/materialui.fd510ed8.svg";